import React from 'react';

const PhysicalSubscription = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66675 11.2871L12.6937 15.9215C12.7802 15.9714 12.8708 16.0075 12.963 16.0303V25.0185L5.23923 20.4475C4.88439 20.2375 4.66675 19.8558 4.66675 19.4435V11.2871ZM23.3334 11.1639V19.4435C23.3334 19.8558 23.1158 20.2375 22.7609 20.4475L15.0371 25.0185V15.9516C15.0559 15.9422 15.0746 15.9322 15.093 15.9215L23.3334 11.1639Z"
      fill="#3448FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.9187 9.03772C5.01675 8.91391 5.1405 8.80927 5.28478 8.73242L13.4514 4.38268C13.7943 4.20008 14.2055 4.20008 14.5483 4.38268L22.715 8.73242C22.8262 8.79166 22.9253 8.86741 23.0097 8.95573L14.0558 14.1253C13.997 14.1592 13.9427 14.1981 13.8932 14.2411C13.8437 14.1981 13.7894 14.1592 13.7306 14.1253L4.9187 9.03772Z"
      fill="#FFC85F"
    />
  </svg>
);

export default PhysicalSubscription;
